module.exports = __webpack_public_path__ + "img/code1.b5fc8f71.png";